import { tsrClient } from '@/libs/ts-rest/ts-client';

export const useProductReviewMutation = () => {
	const createProductReviewMutation = tsrClient.web.reviews.create.useMutation();
	const updateProductReviewMutation = tsrClient.web.reviews.update.useMutation();

	return {
		createProductReviewMutation,
		updateProductReviewMutation,
	};
};
